export const mixpanel = window.mixpanel ?? {
  track: () => {
    console.error(`mixpanel required`);
  },
};
